import { DeleteOutline, Favorite, Refresh } from '@mui/icons-material';
import { ReactComponent as DeleteCicle } from 'assets/svg/delete-circle.svg';
import { useDeletePropertyRequest, useUpdatePropertyRequest } from 'hooks/usePropertyRequests';
import { useState } from 'react';
import usePropertyRequestsStore from 'store/propertyRequestsStore';
import { PropertyLead } from 'types/PropertyLead';
import { formatDate } from 'util/formatDate';
import DeleteRequestModal from './DeleteRequestModal';
import OpenRequestDetailsModal from './OpenRequestDetailsModal';

export default function ArchiveRequests({ lead }: { lead?: PropertyLead }) {
    const [deleteRequestModalVisible, setDeleteRequestModalVisible] = useState(false);
    const [detailsModal, setDetailsModal] = useState(false);
    const { setSelectedLead } = usePropertyRequestsStore();
    const { mutate } = useUpdatePropertyRequest();
    const { mutate: deleteMutate } = useDeletePropertyRequest();
    return (
        <>
            <div className=" w-full font-poppins  bg-gray-50/40 rounded-lg">
                <div className=" bg-white rounded-xl border border-gray-200 font-poppins">
                    <div className="p-6 space-y-4">
                        <h2 className="text-lg font-semibold text-my-black/80">{lead?.title}</h2>
                        <p className="text-my-black/60 text-base font-normal">Move to Archive: {formatDate(lead?.archivedAt!)}</p>
                    </div>

                    {/* Footer */}
                    <div className="border-t border-gray-100">
                        <div className="px-6 py-3 flex justify-between items-center bg-my-gray/20">
                            <div className="flex items-center space-x-2">
                                <Favorite className="text-my-gray/50" />
                                <span className="text-sm font-medium text-my-black/80">
                                    Saved by <span className="font-semibold">{lead?.savedCount}</span> agents
                                </span>
                            </div>
                            <div className="flex gap-4 items-center ">
                                <button
                                    className="p-1 border border-my-gray-800 rounded"
                                    onClick={() => {
                                        mutate({
                                            propertyLeadId: lead!.id,
                                            isArchived: false,
                                        });
                                    }}
                                >
                                    <Refresh className="text-my-blue " />
                                </button>
                                <button className="p-1 border border-my-gray-800 rounded" onClick={() => setDeleteRequestModalVisible(true)}>
                                    <DeleteOutline className="text-my-red" />
                                </button>
                                <div className=" gap-3 bg-white border border-gray-200 rounded-lg default-sm:flex hidden ">
                                    <button
                                        className="text-sm font-semibold py-2.5 px-4 text-my-black/70 hover:text-gray-900"
                                        onClick={() => {
                                            setSelectedLead(lead!);
                                            setDetailsModal(true);
                                        }}
                                    >
                                        View More
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <DeleteRequestModal
                visible={deleteRequestModalVisible}
                onClose={() => setDeleteRequestModalVisible(false)}
                title="Delete Permanently?"
                description="Are you sure you want to delete this request permanently? Once deleted, this request cannot be restored."
                Icon={DeleteCicle}
                onRemove={() => deleteMutate(lead!.id)}
            />
            <OpenRequestDetailsModal isShowArchiveIcon={false} isOpen={detailsModal} setIsOpen={setDetailsModal} />
        </>
    );
}
